import {supabase} from '../supabase/supabase';

export const fetchSellerReviews=async(sellerId)=>{
  if (!sellerId) return [];

  const {data,error}=await supabase
    .from('reviews')
    .select('*')
    .eq('seller_id',sellerId)
    .order('created_at',{ascending:false});

  if (error) throw error;

  return data || [];
};